export default function PlayStore() {
  return window.location.assign(
    "https://play.google.com/store/apps/details?id=com.bismillahid.mihrabmuslimpanel"
  );
}
